document.addEventListener('DOMContentLoaded', function () {

  const videos = document.querySelectorAll('.lazy-video');

  if (!videos.length) return;

  function loadVideo(video) {

    if (video.dataset.loaded) return;

    const sources = video.querySelectorAll('source');

    sources.forEach(function(source) {

      if (source.dataset.src) {
        source.src = source.dataset.src;
      }

    });

    video.dataset.loaded = 'true';

    video.load();

    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch(function(){});
    }

  }

  // fallback
  if (!('IntersectionObserver' in window)) {

    videos.forEach(loadVideo);

    return;

  }

  const observer = new IntersectionObserver(function(entries, observer) {

    entries.forEach(function(entry) {

      if (!entry.isIntersecting) return;
      
      loadVideo(entry.target);

      observer.unobserve(entry.target);

    });

  }, {
    rootMargin: '500px 0px'
  });

  videos.forEach(function(video) {

    observer.observe(video);

  });

});